"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityConversation = exports.EntityConversationDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var comment_1 = require("./comment");
var entity_comment_input_1 = require("./entity-comment-input");
var current_user_can_1 = require("../../utils/current-user-can");
var use_entities_1 = require("../../hooks/use-entities");
var use_lang_1 = require("../../hooks/use-lang");
var use_modal_1 = require("../../hooks/use-modal");
var client_1 = require("@apollo/client");
var immer_1 = __importDefault(require("immer"));
var lodash_1 = require("lodash");
var react_scroll_1 = require("react-scroll");
var icon_1 = require("../elements/icon");
var dialog_1 = require("../elements/dialog");
var icon_button_1 = require("../elements/icon-button");
var sprintf_js_1 = require("sprintf-js");
var loader_1 = require("../elements/loader");
var entity_creator_1 = require("./entity-creator");
var use_app_layout_1 = require("../../hooks/use-app-layout");
var use_active_person_1 = require("../../hooks/use-active-person");
var fecha_1 = __importDefault(require("fecha"));
exports.EntityConversationDefaultProps = {
  anchorName: "conversation",
  stretch: false,
  showHeader: true,
  showInputs: true,
  showCreator: false,
  title: 'Conversation',
  setComments: function () {}
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(14))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n  "], ["\n    padding: ", " ", " ", ";\n  "])), theme_1.theme.UNIT(0), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3)),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n  "], ["\n    padding: ", " ", " ", ";\n  "])), theme_1.theme.UNIT(0), theme_1.theme.UNIT(5), theme_1.theme.UNIT(3))
});
var CommentsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n\n    > li:first-child {\n      border-top: none;\n    }\n  "], ["\n    margin: 0;\n    padding: 0;\n\n    > li:first-child {\n      border-top: none;\n    }\n  "])))
});
var CommentItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: ", " 0 ", " 0;\n    margin: 0;\n    list-style: none;\n  "], ["\n    padding: ", " 0 ", " 0;\n    margin: 0;\n    list-style: none;\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(1)),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", " 0 ", " 0;\n  "], ["\n    padding: ", " 0 ", " 0;\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(1))
});
var REPLY_INDENT_UNITS = 13;
var RepliesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    background: none;\n    margin-left: ", ";\n    margin-top: ", ";\n  "], ["\n    ", ";\n    background: none;\n    margin-left: ", ";\n    margin-top: ", ";\n  "])), CommentsStyles, theme_1.theme.UNIT(REPLY_INDENT_UNITS), theme_1.theme.UNIT(1))
});
var ReplyItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    padding-top: ", ";\n  "], ["\n    ", ";\n    padding-top: ", ";\n  "])), CommentItemStyles, theme_1.theme.UNIT(2)),
  tablet: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var CommentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ReplyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var CommentInputStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n  "], ["\n    ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n  "])), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(3.5, 2), theme_1.theme.UNIT(3.5)),
  tablet: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    padding-top: ", ";\n    padding-bottom: ", ";\n  "], ["\n    padding-top: ", ";\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4, 2), theme_1.theme.UNIT(3))
});
var CommentEditInputStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ReplyInputStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    margin-left: ", ";\n    padding-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    margin-left: ", ";\n    padding-top: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(REPLY_INDENT_UNITS), theme_1.theme.UNIT(3), theme_1.theme.UNIT(6)),
  tablet: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ReplyEditInputStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    padding: 0 ", ";\n    display: flex;\n    flex-direction: column;\n    padding-bottom: ", ";\n    ", ";\n  "], ["\n    padding: 0 ", ";\n    display: flex;\n    flex-direction: column;\n    padding-bottom: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3, 2), theme_1.theme.H_DOT_BG_END()),
  tablet: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  "], ["\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  "])))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    font-size: 1em;\n    color: ", ";\n    text-transform: uppercase;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    margin: ", " 0;\n  "], ["\n    font-size: 1em;\n    color: ", ";\n    text-transform: uppercase;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    margin: ", " 0;\n  "])), theme_1.theme.COLOR('dark'), theme_1.theme.UNIT(3)),
  desktop: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 15 / 14)
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var DeleteDialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DeleteConfirmButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var CreatorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    margin-left: -1px;\n  "], ["\n    margin-left: -1px;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    margin-left: 0px;\n  "], ["\n    margin-left: 0px;\n  "])))
});
var FooterStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n    position: fixed;\n    bottom: 0;\n    box-sizing: border-box;\n    background: ", ";\n    z-index: 100;\n    border-top: 1px solid ", ";\n    padding: ", " ", " ", ";\n\n    ", "\n  "], ["\n    position: fixed;\n    bottom: 0;\n    box-sizing: border-box;\n    background: ", ";\n    z-index: 100;\n    border-top: 1px solid ", ";\n    padding: ", " ", " ", ";\n\n    ", "\n  "])), theme_1.theme.COLOR('app-chrome'), theme_1.theme.COLOR('line-subtle'), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), function (_a) {
    var _width = _a._width;
    return (0, styled_components_1.css)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n      width: ", "px;\n    "], ["\n      width: ", "px;\n    "])), _width);
  })
});
var FooterCommentInputStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(react_scroll_1.Element)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Header: styled_components_1.default.header(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Title: styled_components_1.default.h1(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Creator: (0, styled_components_1.default)(entity_creator_1.EntityCreator)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), CreatorStyles),
  Comments: styled_components_1.default.ul(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), CommentsStyles),
  CommentItem: styled_components_1.default.li(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), CommentItemStyles),
  Comment: (0, styled_components_1.default)(comment_1.Comment)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), CommentStyles),
  CommentInput: (0, styled_components_1.default)(entity_comment_input_1.EntityCommentInput)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), CommentInputStyles),
  CommentEditInput: (0, styled_components_1.default)(entity_comment_input_1.EntityCommentInput)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), CommentEditInputStyles),
  FooterCommentInput: (0, styled_components_1.default)(entity_comment_input_1.EntityCommentInput)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), FooterCommentInputStyles),
  Replies: styled_components_1.default.ul(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), RepliesStyles),
  ReplyItem: styled_components_1.default.li(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), ReplyItemStyles),
  Reply: (0, styled_components_1.default)(comment_1.Comment)(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), ReplyStyles),
  ReplyInput: (0, styled_components_1.default)(entity_comment_input_1.EntityCommentInput)(templateObject_46 || (templateObject_46 = __makeTemplateObject(["", ""], ["", ""])), ReplyInputStyles),
  ReplyEditInput: (0, styled_components_1.default)(entity_comment_input_1.EntityCommentInput)(templateObject_47 || (templateObject_47 = __makeTemplateObject(["", ""], ["", ""])), ReplyEditInputStyles),
  DeleteDialog: (0, styled_components_1.default)(dialog_1.Dialog)(templateObject_48 || (templateObject_48 = __makeTemplateObject(["", ""], ["", ""])), DeleteDialogStyles),
  DeleteConfirmButton: (0, styled_components_1.default)(icon_button_1.SubmitIconButton)(templateObject_49 || (templateObject_49 = __makeTemplateObject(["", ""], ["", ""])), DeleteConfirmButtonStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_50 || (templateObject_50 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  Footer: styled_components_1.default.div(templateObject_51 || (templateObject_51 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles)
};
var EntityConversation = function (props) {
  var className = props.className,
    onSubmit = props.onSubmit,
    anchorName = props.anchorName,
    setComments = props.setComments,
    onInputFocus = props.onInputFocus,
    onInputBlur = props.onInputBlur,
    stretch = props.stretch,
    showInputs = props.showInputs,
    showNewCommentInFooter = props.showNewCommentInFooter,
    entity = props.entity;
  var comments = props.comments;
  var entities = (0, use_entities_1.useEntities)();
  var t = (0, use_lang_1.useLang)();
  var user = (0, use_active_person_1.useActivePerson)();
  var Comment = entities.Comment;
  var modal = (0, use_modal_1.useModal)();
  var availableHeight = (0, use_app_layout_1.useAppLayout)().availableHeight;
  var bodyHeight = availableHeight; /* - ((footerInfo && footerInfo.height) || 0); */
  var canCreateComments = showInputs && (0, current_user_can_1.personCanCreate)(user, 'comments');
  var _a = __read((0, client_1.useMutation)(Comment.create.mutation), 2),
    createComment = _a[0],
    createError = _a[1].error;
  var _b = __read((0, client_1.useMutation)(Comment.update.mutation), 2),
    updateComment = _b[0],
    updateError = _b[1].error;
  var _c = __read((0, client_1.useMutation)(Comment.delete.mutation), 2),
    deleteComment = _c[0],
    deleteError = _c[1].error;
  var _d = __read((0, react_1.useState)(), 2),
    editingComment = _d[0],
    setEditingComment = _d[1];
  var _e = __read((0, react_1.useState)(false), 2),
    deleting = _e[0],
    setDeleting = _e[1];
  var _f = __read((0, react_1.useState)(false), 2),
    submitting = _f[0],
    setSubmitting = _f[1];
  var _g = __read((0, react_1.useState)(null), 2),
    submittingReplyFor = _g[0],
    setSubmittingReplyFor = _g[1];
  var _h = __read((0, react_1.useState)(null), 2),
    submittingUpdateFor = _h[0],
    setSubmittingUpdateFor = _h[1];
  var hasComments = !!comments.length;
  var handleCancel = function () {
    setEditingComment(null);
  };
  var modalLabel = function (isReply) {
    return isReply ? t('Reply') : t('Comment');
  };
  var modalTitle = function (isReply) {
    var label = modalLabel(isReply);
    return (0, sprintf_js_1.sprintf)(t('Delete %s'), label);
  };
  var onDelete = function (id, isReply) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        setDeleting(true);
        modal.show(react_1.default.createElement(My.DeleteDialog, {
          title: modalTitle(isReply),
          isCancelButtonDisabled: true
        }, react_1.default.createElement(My.Loader, {
          spinnerSize: 18
        })));
        deleteComment({
          variables: {
            id: id
          }
        });
        setComments((0, immer_1.default)(comments, function (draft) {
          (0, lodash_1.forEach)(comments, function (comment, index) {
            if (comment.id === id) {
              draft.splice(index, 1);
            } else {
              (0, lodash_1.forEach)(comment.replies || [], function (reply, replyIndex) {
                if (reply.id === id) {
                  draft[index].replies.splice(replyIndex, 1);
                }
              });
            }
          });
        }));
        setDeleting(false);
        modal.hide();
        return [2 /*return*/];
      });
    });
  };
  var confirmDelete = function (id, isReply) {
    var label = modalLabel(isReply);
    modal.show(react_1.default.createElement(My.DeleteDialog, {
      onCancel: function () {
        return modal.hide();
      },
      isCancelButtonDisabled: deleting,
      button: !deleting && react_1.default.createElement(My.DeleteConfirmButton, {
        onClick: function () {
          return onDelete(id, isReply);
        }
      }, t('Confirm')),
      title: modalTitle(isReply)
    }, (0, sprintf_js_1.sprintf)(t('Are you sure you want to delete this %s?'), label), react_1.default.createElement("br", null), react_1.default.createElement("br", null), react_1.default.createElement("b", null, t('This is not reversible.'))));
  };
  var handleSubmit = function (_a) {
    var parent = _a.parent,
      id = _a.id;
    return function (_a) {
      return __awaiter(void 0, [_a], void 0, function (_b) {
        var entityTypeName, definition, valid, fieldName, metadata, input, result, updatedComment_1, newState, input, dateStr, result, newComment_1, newState;
        var _c, _d;
        var value = _b.value;
        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              entityTypeName = entity.__typename;
              definition = entities[entityTypeName];
              if (!definition) {
                throw new Error("Cannot find the entity type ".concat(entityTypeName, " to attach this comment to."));
              }
              valid = true;
              fieldName = definition.singleTypeName;
              metadata = {
                parent: {
                  name: entity.name,
                  id: entity.id,
                  type: entityTypeName
                }
              };
              if (!id) return [3 /*break*/, 2];
              setSubmittingUpdateFor(id);
              input = (_c = {
                metadata: metadata,
                parent: parent
              }, _c[fieldName] = entity.id, _c.description = value, _c);
              return [4 /*yield*/, updateComment({
                variables: {
                  id: id,
                  input: input
                }
              })];
            case 1:
              result = _e.sent();
              if (!(updateError && updateError.graphQLErrors && updateError.graphQLErrors.length)) {
                setSubmittingUpdateFor(null);
                setEditingComment(null);
                updatedComment_1 = result.data.updateComment;
                newState = (0, immer_1.default)(comments, function (draft) {
                  (0, lodash_1.forEach)(comments, function (comment, index) {
                    // if parent is this comment, push this reply
                    if (comment.id === updatedComment_1.id) {
                      draft[index] = updatedComment_1;
                    } else {
                      (0, lodash_1.forEach)(comment.replies || [], function (reply, replyIndex) {
                        if (reply.id === updatedComment_1.id) {
                          draft[index].replies[replyIndex] = updatedComment_1;
                        }
                      });
                    }
                  });
                });
                setComments(newState);
              } else {
                valid = false;
              }
              return [3 /*break*/, 4];
            case 2:
              if (parent) {
                setSubmittingReplyFor(parent);
              } else {
                setSubmitting(true);
              }
              input = (_d = {
                metadata: metadata,
                parent: parent
              }, _d[fieldName] = entity.id, _d.description = value, _d);
              dateStr = fecha_1.default.format(new Date(), 'YYYY-MM-DDTHH:mm:ss');
              return [4 /*yield*/, createComment({
                variables: {
                  input: input
                }
              })];
            case 3:
              result = _e.sent();
              if (!(createError && createError.graphQLErrors && createError.graphQLErrors.length)) {
                newComment_1 = result.data.createComment;
              }
              if (parent) {
                // this was a reply to another comment
                setSubmittingReplyFor(null);
                if (newComment_1) {
                  newState = (0, immer_1.default)(comments, function (draft) {
                    (0, lodash_1.forEach)(draft, function (comment) {
                      // if parent is this comment, push this reply
                      if (comment.id === parent) {
                        comment.replies = comment.replies || [];
                        comment.replies.push(newComment_1);
                      }
                    });
                  });
                  setComments(newState);
                }
              } else {
                // this is a top level comment, simply append the comment to the set
                setSubmitting(false);
                setComments(__spreadArray(__spreadArray([], __read(comments), false), [newComment_1], false));
              }
              _e.label = 4;
            case 4:
              if (onSubmit) {
                onSubmit({
                  value: value,
                  parent: parent
                }); //
              }
              return [2 /*return*/];
          }
        });
      });
    };
  };
  return react_1.default.createElement(My.Container, {
    _height: stretch ? bodyHeight : 0,
    id: anchorName,
    name: anchorName,
    className: className
  }, react_1.default.createElement(My.Body, null, hasComments && react_1.default.createElement(My.Comments, null, comments.map(function (comment, c) {
    return react_1.default.createElement(My.CommentItem, {
      key: "comment-".concat(comment.id)
    }, editingComment === comment.id ? react_1.default.createElement(My.CommentEditInput, {
      onFocus: onInputFocus,
      onBlur: onInputBlur,
      autoFocus: true,
      creator: comment.createdBy,
      isEdit: true,
      initialValue: comment.description && comment.description.text,
      isSubmitting: comment.id === submittingUpdateFor,
      onCancel: handleCancel,
      onSubmit: handleSubmit({
        id: comment.id
      })
    }) : react_1.default.createElement(My.Comment, {
      showEditControls: showInputs,
      canEdit: user.person && comment.createdBy.id === user.person.id || (0, current_user_can_1.personCanAdmin)(user),
      canDelete: !comment.replies.length,
      onDelete: function () {
        return confirmDelete(comment.id);
      },
      entity: comment,
      onEdit: function () {
        return setEditingComment(comment.id);
      }
    }), react_1.default.createElement(react_1.default.Fragment, null, comment.replies && !!comment.replies.length && react_1.default.createElement(My.Replies, null, comment.replies.map(function (reply, r) {
      return react_1.default.createElement(My.ReplyItem, {
        key: "reply-".concat(reply.id)
      }, editingComment === reply.id ? react_1.default.createElement(My.ReplyEditInput, {
        onFocus: onInputFocus,
        onBlur: onInputBlur,
        creator: reply.createdBy,
        autoFocus: true,
        isEdit: true,
        initialValue: reply.description && reply.description.text,
        isSubmitting: reply.id === submittingUpdateFor,
        onCancel: handleCancel,
        onSubmit: handleSubmit({
          id: reply.id,
          parent: comment.id
        }),
        isReply: true
      }) : react_1.default.createElement(My.Reply, {
        showEditControls: showInputs,
        canDelete: true,
        canEdit: user.person && reply.createdBy.id === user.person.id || (0, current_user_can_1.personCanAdmin)(user),
        onDelete: function () {
          return confirmDelete(reply.id, true);
        },
        isReply: true,
        entity: reply,
        onEdit: function () {
          return setEditingComment(reply.id);
        }
      }));
    })), canCreateComments &&
    // set a key underneath so that the value is reset (react mounts a new copy) when it's another comment
    react_1.default.createElement(My.ReplyInput, {
      onFocus: onInputFocus,
      onBlur: onInputBlur,
      key: "reply-input-".concat(comment.id, "-").concat(comment.replies.length),
      disabled: !!editingComment,
      isSubmitting: comment.id === submittingReplyFor,
      onSubmit: handleSubmit({
        parent: comment.id
      }),
      isReply: true
    })));
  })), canCreateComments && react_1.default.createElement(My.CommentInput, {
    onFocus: onInputFocus,
    onBlur: onInputBlur,
    key: "comment-input-".concat(comments.length),
    disabled: !!editingComment,
    isSubmitting: submitting,
    onSubmit: handleSubmit({})
  })));
};
exports.EntityConversation = EntityConversation;
exports.EntityConversation.defaultProps = exports.EntityConversationDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51;